<nav class="sidebar h-100 py-3" [class.sidebar-dark]="sidebarDark" aria-label="Section">
  <ul class="nav flex-column">
    @for (navItem of navItems; track navItem.label) {
      <li class="nav-item">
        <a
          [routerLink]="navItem.path"
          routerLinkActive="active"
          [ariaCurrentWhenActive]="'page'"
          class="nav-link d-flex justify-content-between align-items-center"
          (click)="onLinkClick()"
        >
          {{ navItem.label }}
        </a>
      </li>
    }
  </ul>
</nav>
